import { render, staticRenderFns } from "./SmsList.vue?vue&type=template&id=4ab972a4&scoped=true&"
import script from "./SmsList.vue?vue&type=script&lang=js&"
export * from "./SmsList.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&id=4ab972a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab972a4",
  null
  
)

export default component.exports